import { observer } from 'mobx-react'
import * as Yup from 'yup'
import { Field, Form, Formik } from 'formik'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { InputFieldGroup } from '../../molecules/InputFieldGroup'
import { useStores } from '../../../utils'
import { MessageType } from '../../../types'
import { Button } from '../../atoms/Button'

type Values = {
  email: string
}

const initialValues: Values = {
  email: '',
}

export const PasswordSettingSection = observer(() => {
  const { t } = useTranslation(['password-recovery', 'validation'])
  const { viewer, messages } = useStores()

  const validationSchema = Yup.object().shape({
    email: Yup.string().email(t('validation:メールアドレスの形式が違います')).required(t('validation:必須項目です')),
  })

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values: Values, actions) => {
        const isSuccessful = await viewer.sendResetPasswordRequest(values.email)
        actions.setSubmitting(false)
        if (isSuccessful) {
          messages.add({
            type: MessageType.Info,
            body: t('ご指定のメールアドレス宛にパスワード再設定用のリンクをお送りしました'),
            isTranslated: true,
            ttl: 5000,
          })
          actions.resetForm()
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <p className={styles.text}>{t('パスワードを再設定するメールアドレスをご入力ください')}</p>
          <div className={styles.inputContainer}>
            <Field name='email' type='email' placeholder={t('メールアドレス')} component={InputFieldGroup} />
          </div>
          <div className={styles.button} role='button' tabIndex={0}>
            <Button isLoading={isSubmitting} disabled={isSubmitting} buttonSize='large' buttonType='submit'>
              {t('メールを送信')}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
})
